<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        
        <CCardBody class="tips_statistic_table_modify">
            <h5>{{ $t('Stats') }}</h5>
            <CDataTable
                :items="items1"
                :fields="fields"
                hover
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">                
                    <tr class="first_tr">
                        <th colspan="3">{{ $t('League') }}</th>
                        <th colspan="6">{{ $t('Match Result %') }}</th>
                        <th colspan="3">{{ $t('Average Goals') }}</th>
                        <th colspan="3">{{ $t('Fist Half Overs %') }}</th>
                        <th colspan="3">{{ $t('Second Half Overs %') }}</th>
                        <th colspan="5">{{ $t('Full Match Overs %') }}</th>
                        <th colspan="1"></th>
                        <th colspan="6">{{ $t('Goal Bands [% of matches with at least one goal in time period') }}</th>
                        <th colspan="2">{{ $t('1st goal avg min') }}</th>
                        <th colspan="4">{{ $t('First To Score') }}</th>
                    </tr>                  
                </template>
                <template #Matches="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <a :href="'/#/viewevents?idlist=' + item.Matches_ids" target="_blank">{{item.Matches}}</a>
                    </td>
                   
                </template>
            </CDataTable>

            <h5>{{ $t('Stats by league') }}</h5>
            <CDataTable
                :items="items2"
                :fields="fields"
                sorter
                tableFilter
                hover
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">                
                    <tr class="first_tr">
                        <th colspan="3">{{ $t('League') }}</th>
                        <th colspan="6">{{ $t('Match Result %') }}</th>
                        <th colspan="3">{{ $t('Average Goals') }}</th>
                        <th colspan="3">{{ $t('Fist Half Overs %') }}</th>
                        <th colspan="3">{{ $t('Second Half Overs %') }}</th>
                        <th colspan="5">{{ $t('Full Match Overs %') }}</th>
                        <th colspan="1"></th>
                        <th colspan="6">{{ $t('Goal Bands [% of matches with at least one goal in time period') }}</th>
                        <th colspan="2">{{ $t('1st goal avg min') }}</th>
                        <th colspan="4">{{ $t('First To Score') }}</th>
                    </tr>                
                </template>
                <template #Matches="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <a :href="'/#/viewevents?idlist=' + item.Matches_ids" target="_blank">{{item.Matches}}</a>
                    </td>
                   
                </template>
            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import { mapActions, mapGetters } from 'vuex';
// const fields = [
//     this.$t('Country'),
//     'League',    
//     'Matches',
//     'home',
//     'draw',
//     'away',
//     { key: '1st Half', label: '1st Half', _style: "width: '50px'" },
//     '2nd Half',
//     'total',
//     { key: '0.5 FH', label: '0.5 FH'},
//     { key: '1.5 FH', label: '1.5 FH'},
//     { key: '2.5 FH', label: '2.5 FH'},
//     { key: '0.5', label: '0.5'},
//     { key: '1.5', label: '1.5'},
//     { key: '2.5', label: '2.5'},
//     { key: '3.5', label: '3.5'},
//     { key: '4.5', label: '4.5'},    
    
//     'bts',
//     '0~15',
//     '16~30',
//     '31~45',
//     '46~60',
//     '61~75',
//     '76~90',
//     'Home',
//     'H Win',
//     'Away',
//     'A Win'
// ]


export default {
    name: 'StatisticTable',
    components: {
        Plotly,
       
    },
    props: {
        items1: {
            type: Array,
            default: () => []
        },
        items2: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            
            startDate: 1325376000000,
            endDate: 1330560000000,
            
            fields: [
                { key: 'Country', label: this.$t('Country')},
                { key: 'League', label: this.$t('League')},
                { key: 'Matches', label: this.$t('Matches')},
                { key: 'home', label: this.$t('home')},
                { key: 'draw', label: this.$t('draw')},
                { key: 'away', label: this.$t('away')},
                { key: 'home_pt_percent', label: this.$t('home fh')},
                { key: 'draw_pt_percent', label: this.$t('draw fh')},
                { key: 'away_pt_percent', label: this.$t('away fh')},
                { key: '1st Half', label: this.$t('1st Half'), _style: "width: '50px'" },
                { key: '2nd Half', label: this.$t('2nd Half')},
                { key: 'total', label: this.$t('total')},                
                { key: '0.5 FH', label: this.$t('0.5 FH')},
                { key: '1.5 FH', label: this.$t('1.5 FH')},
                { key: '2.5 FH', label: this.$t('2.5 FH')},
                { key: 'sh_05_percent', label: this.$t('0.5 SH')},
                { key: 'sh_15_percent', label: this.$t('1.5 SH')},
                { key: 'sh_25_percent', label: this.$t('2.5 SH')},
                { key: '0.5', label: '0.5'},
                { key: '1.5', label: '1.5'},
                { key: '2.5', label: '2.5'},
                { key: '3.5', label: '3.5'},
                { key: '4.5', label: '4.5'},                
                'bts',
                '0~15',
                '16~30',
                '31~45',
                '46~60',
                '61~75',
                '76~90',
                { key: 'ht_firstGoal_min_avg', label: this.$t('FH')},
                { key: 'sh_firstGoal_min_avg', label: this.$t('SH')},
                { key: 'Home', label: this.$t('Home')},
                { key: 'H Win', label: this.$t('H Win')},
                { key: 'Away', label: this.$t('Away')},
                { key: 'A Win', label: this.$t('A Win')}                
            ],
            loading: true
        }
    },
    created() {
        console.log('==============  created function')
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        ...mapActions([
                'getStatsByUserId'
            ]),
        
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>
<style scoped>

</style>
<style>


.tips_statistic_table_modify .table-responsive{
    margin-top: 20px !important;
    max-height: 60vh !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
</style>